import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar       from '../components/Navbar';
import Hero         from '../components/Hero';
import DonationForm from '../components/DonationForm';
import Footer       from '../components/Footer';

export default function Home() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <Hero />

      {/* About section */}
      <section id="about" className="py-5 py-lg-6" style={{ background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-3"
                style={{ background: 'rgba(58,175,228,.1)', border: '1.5px solid rgba(58,175,228,.3)' }}>
                <i className="bi bi-globe2" style={{ color: 'var(--primary)' }} />
                <span style={{ color: 'var(--primary)', fontWeight: 700, fontSize: '.85rem' }}>{t('nav.about')}</span>
              </div>
              <h2 className="section-title mb-4">{t('about.title')}</h2>
              <p className="text-muted fs-5 mb-3" style={{ lineHeight: 1.9 }}>{t('about.p1')}</p>
              <p className="text-muted fs-5 mb-4" style={{ lineHeight: 1.9 }}>{t('about.p2')}</p>
              <a href="#donate" className="btn btn-donate px-5 py-3">
                <i className="bi bi-heart-fill me-2" />
                {t('hero.donateBtn')}
              </a>
            </div>
            <div className="col-lg-6">
              <div className="row g-3">
                {[
                  { icon: 'bi-palette2',            titleKey: 'card1Title', textKey: 'card1Text', color: '#3AAFE4' },
                  { icon: 'bi-hand-thumbs-up-fill', titleKey: 'card2Title', textKey: 'card2Text', color: '#1A7DB5' },
                  { icon: 'bi-mortarboard-fill',    titleKey: 'card3Title', textKey: 'card3Text', color: '#FFD600' },
                ].map((c, i) => (
                  <div key={i} className="col-12">
                    <div className="card border-0 shadow-sm rounded-4 p-4 card-lift d-flex flex-row align-items-start gap-4">
                      <div style={{
                        width: '60px', height: '60px', flexShrink: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: c.color === '#FFD600' ? 'rgba(255,214,0,.15)' : `${c.color}15`,
                        borderRadius: '16px',
                        border: `1.5px solid ${c.color}40`,
                      }}>
                        <i className={`bi ${c.icon}`} style={{ fontSize: '1.6rem', color: c.color }} />
                      </div>
                      <div>
                        <h5 className="fw-bold mb-1" style={{ color: c.color === '#FFD600' ? '#1A7DB5' : c.color }}>
                          {t(`about.${c.titleKey}`)}
                        </h5>
                        <p className="mb-0 text-muted">{t(`about.${c.textKey}`)}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Wave divider */}
      <div style={{ lineHeight: 0, background: '#fff' }}>
        <svg viewBox="0 0 1200 60" preserveAspectRatio="none" style={{ width: '100%', height: '50px', display: 'block' }}>
          <path d="M0,30 C300,60 900,0 1200,30 L1200,60 L0,60 Z" fill="var(--light)" />
        </svg>
      </div>

      <DonationForm />

      <Footer />
    </>
  );
}
